import React from 'react'

export default function Sectioncopyright() {
    return (
        <>
            {/* <div className='copyright-bar'>&copy; copyright&nbsp; 2024&nbsp; all&nbsp; rights&nbsp; reserved</div> */}
            <div className='copyright-bar'> ©2024. | Designed By: Atish Basak. | All rights reserved. </div>
        </>                                              
    )
}
